"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _semanticUiReact = require("semantic-ui-react");

var _Fonts = require("../../00_environment/Fonts");

var _Button = _interopRequireDefault(require("../../01_atoms/Button"));

var _FormContainer = _interopRequireDefault(require("../../01_atoms/FormContainer"));

var _DefaultScreen = _interopRequireDefault(require("../../02_molecules/DefaultScreen"));

var _TitledContainer = _interopRequireDefault(require("../../01_atoms/TitledContainer"));

var _ResponsiveCentralPaneWrapper = _interopRequireDefault(require("../../02_molecules/ResponsiveCentralPaneWrapper"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var ForgotPasswordLinkSentPageUI = function ForgotPasswordLinkSentPageUI(_ref) {
  var translatorForNamespace = _ref.translatorForNamespace,
      _ref$onBack = _ref.onBack,
      onBack = _ref$onBack === void 0 ? function () {} : _ref$onBack;
  var t = translatorForNamespace('ForgotPasswordLinkSentPageUI');
  return /*#__PURE__*/_react["default"].createElement(_DefaultScreen["default"], {
    title: t('Reset your password'),
    onBack: onBack
  }, /*#__PURE__*/_react["default"].createElement(_ResponsiveCentralPaneWrapper["default"], null, /*#__PURE__*/_react["default"].createElement(_TitledContainer["default"], {
    title: t('Reset your password'),
    rightButtonText: t('Back'),
    onRightButtonClick: onBack
  }, /*#__PURE__*/_react["default"].createElement(_FormContainer["default"], null, /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      flex: '1',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center'
    }
  }, /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Header, {
    icon: true,
    style: (0, _Fonts.withWidgetTitleFont)({
      marginTop: '5%',
      marginBottom: '5%'
    })
  }, /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Icon, {
    name: "check"
  }), t('Done.'), /*#__PURE__*/_react["default"].createElement("br", null), t("You'll receive a link shortly.")), /*#__PURE__*/_react["default"].createElement(_Button["default"], {
    onClick: onBack,
    fluid: true,
    primary: true
  }, t('Back')))))));
};

var _default = ForgotPasswordLinkSentPageUI;
exports["default"] = _default;